import { Box, styled } from "@material-ui/core";
import {
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../_lib/epocus-palette";

const Title = styled("h1")({
  margin: 0,
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
  fontSize: rem(24),
  lineHeight: 1.2,
});

const Subtitle = styled("p")({
  margin: 0,
  fontSize: rem(13),
  color: EPOCUS_TEXT_SECONDARY,
  marginTop: 4,
});

export const AdminPageHeader: FC<{ title: string; subtitle?: string }> = ({
  title,
  subtitle,
}) => (
  <Box>
    <Title>{title}</Title>
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </Box>
);
